
import { TranslateService } from '@ngx-translate/core';


export const Level: any[]= [
    //{ id:620,name: 'Nivel Medio ( y  años)',name2:'1' },
    { id:2,name: 'Medio Mayor (3 y 4 años)',name2:'2' },
    //{ id:621,name: 'Nivel Transición ( y  años)',name2:'3' },
    { id:3,name: 'Pre Kinder (4 y 5 años)' ,name2:'4'},
    { id:4,name: 'Kinder (5 y 6 años)' ,name2:'5'},
    { id:5,name: 'Primero Básico (6 y 7 años)' ,name2:'6'},
    { id:6,name: 'Segundo Básico (7 y 8 años)' ,name2:'7'},
    { id:7,name: 'Tercero Básico (8 y 9 años)' ,name2:'8'},
    { id:8,name: 'Cuarto Básico (9 y 10 años)' ,name2:'9'},
    { id:9,name: 'Quinto Básico (10 y 11 años)' ,name2:'10'},
    { id:10,name: 'Sexto Básico (11 y 12 años)' ,name2:'11'},
    { id:11,name: 'Séptimo Básico (12 y 13 años)' ,name2:'12'},
    { id:62,name: 'Octavo Básico (13 y 14 años)' ,name2:'13'},
    { id:163,name: 'Noveno Básico (14 y 15 años)' ,name2:'14'},
    { id:183,name: 'Décimo Básico (15 y 16 años)' ,name2:'15'},
    { id:745,name: 'Onceavo Básico (16 y 17 años)' ,name2:'16'},
    { id:746,name: 'Doceavo Básico (17 y 18 años)' ,name2:'17'}
  ];